import {
    MyResultTableEntryModel,
    ManagerSraQuestionnaireResultModel,
    TeamSraQuestionnaireResultModel
} from "@teamprevent/common/stressRiskAssessment/models";

import { SraAction } from "./actions";
import * as actionTypes from "./actionTypes";

export function sraTasks(state: MyResultTableEntryModel[] = [], action: SraAction): MyResultTableEntryModel[]  {
    switch (action.type) {
        case actionTypes.LOAD_SRA_TASKS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function sraResults(state: ManagerSraQuestionnaireResultModel = null, action: SraAction): ManagerSraQuestionnaireResultModel {
    switch (action.type) {
        case actionTypes.LOAD_SRA_RESULTS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function teamSraResults(state: TeamSraQuestionnaireResultModel = null, action: SraAction): TeamSraQuestionnaireResultModel {
    switch (action.type) {
        case actionTypes.LOAD_TEAM_SRA_RESULTS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
